import * as React from 'react'
import { CheckSkinnyIcon } from '../igniter/Icons'
import { PurchaseOption } from './lib/purchase_option'
import { TaxInformation } from './lib/tax_information'

interface IProps {
  purchaseOption: PurchaseOption
  trialActivationPrice: number
  trial: boolean
  trialLength: number
  taxInformation: TaxInformation
}

export class Cart extends React.Component<IProps, object> {
  public benefits() {
    const { purchaseOption: { membershipPlan } } = this.props
    const { checkoutBenefits } = membershipPlan

    return (
      checkoutBenefits.map((benefit) => <li key={benefit}>{benefit} <CheckSkinnyIcon /></li>)
    )
  }

  public includedTrialDownloads() {
    const { purchaseOption: { membershipPlan } } = this.props
    const { includedItemsInTrial } = membershipPlan

    return (
      includedItemsInTrial.map((item) => <li key={item}>{item}</li>)
    )
  }

  public trialIncludes() {
    const { trialLength } = this.props

    return (
      <section className="trial-includes">
        <h4>{trialLength}-Day FREE Trial includes:</h4>
        <ul>
          {this.includedTrialDownloads()}
        </ul>
      </section>
    )
  }

  public priceDetails(description: string, price: number) {
    return (
      <li key={description} className="price-detail">
        <span className="description">{description}</span>
        <span className="amount">${this.formatPrice(price)}</span>
      </li>
    )
  }

  public renderPlanName() {
    const { purchaseOption } = this.props
    const {
      membershipPlan,
    } = purchaseOption
    const { name: planName } = membershipPlan

    return(
      <>
        <span className="plan-name">{planName} Plan</span>
        <span className="price">
          ${this.formatPrice(purchaseOption.fullPrice())}
          <sub>/{purchaseOption.paymentFrequencyLabel()}</sub>
        </span>
      </>
    )
  }

  public render() {
    const {
      purchaseOption: { paymentDetails, membershipPlan },
      trial,
    } = this.props
    const {
      name: planName,
    } = membershipPlan

    return (
      <section className="order-summary">
        <h2>Order Summary</h2>

        <div className="cart">
          <h3>
            {this.renderPlanName()}
          </h3>

          <section className="benefits">
            <ul>
              {this.benefits()}
            </ul>
          </section>

          {trial ? this.trialIncludes() : null}

          <section className="billing-plan">
            <ul>
              <li>
                <span className="description">Billing Plan</span>
                <span className="value"><strong>{paymentDetails.paymentTerm}</strong></span>
              </li>
            </ul>
          </section>

          <section className="price-breakdown">
            <ul>
              {this.priceDetails(`${planName} Plan`, paymentDetails.basePrice)}
              {this.renderAdjustments()}
              {this.renderTaxDetails()}
            </ul>
          </section>

          <section className="total">
            <ul>
              {this.renderTrialActivationPrice()}

              <li className="price-detail due-today">
                <span className="description">Total Due Today</span>
                <span className="amount"><sup>$</sup>{this.formatPrice(this.totalDueToday())}</span>
              </li>
            </ul>
          </section>
          <section className="tax-notes">
              {this.renderTaxNotes()}
          </section>
        </div>
      </section>
    )
  }

  protected renderTaxDetails() {
    const {
      taxInformation,
    } = this.props

    if (taxInformation.isLoaded) {
      return this.priceDetails(taxInformation.salesTaxLabel, taxInformation.salesTaxAmount || 0)
    } else {
      return (
        <li className="price-detail">
          <span className="description">{taxInformation.salesTaxLabel}</span>
          <span className="amount">Calculating...</span>
        </li>
      )
    }
  }

  protected renderTaxNotes() {
    const {
      taxInformation,
    } = this.props

    if (taxInformation.salesTaxAmount) {
      return(
        <>
          <p>
            * Tax exempt? No problem. Proceed to checkout and you can submit your sales tax exemption
            certificate in the Billing section of your account for a sales tax refund.
          </p>
          <a href="https://ignitermedia.zendesk.com/hc/en-us/articles/360042745311-Sales-Tax-Update" target='_blank'>Why am I being charged sales tax?</a>
        </>
      )
    }
  }

  protected renderAdjustments() {
    const { purchaseOption: { paymentDetails } } = this.props

    return paymentDetails.adjustments.map((a) => {
      if (a.value === 0) { return null }

      return this.priceDetails(a.label, a.value)
    })
  }

  protected renderTrialActivationPrice() {
    const { trial } = this.props
    const { purchaseOption: { paymentDetails } } = this.props

    if (!trial) { return null }

    if (paymentDetails.numberOfPayments == 1) {
      return this.priceDetails('Trial Activation Price', this.paymentTotal())
    } else {
      return this.priceDetails('12 Monthly Installments After Trial', this.paymentTotal())
    }
  }

  protected totalDueToday(): number {
    const { trial } = this.props

    if (trial) {
      return 0.00
    } else {
      return this.paymentTotal()
    }
  }

  protected paymentTotal(): number {
    const { purchaseOption: { paymentDetails }, taxInformation } = this.props

    return paymentDetails.total({ taxInformation })
  }

  protected formatPrice(price: number): string {
    return Number(price).toFixed(2)
  }
}
